import { extend } from '@/components/composables/use-expose'
import Dialog from '@anypromo/components-mobile/Dialog'
import { ImprintMethodModel } from '@/pages/quote-customize/types/ImprintMethod'
import {
  type IProductSpecModel,
  type ISpecModel,
  type IProductionTimeItem,
  type IDropShipModel,
  type IQuantitySize
} from '@/pages/quote-customize/types'
import { type AxiosRequestConfig } from 'axios'
import {defaultHttpClient as axios} from '@anypromo/shared/api/_HttpClient'

import { OrderType } from '@anypromo/shared/types/SaleCustomize'
import { type ILastCartItem } from '@/pages/sale-customize/types'
import { type ICustomizeEventInfo } from '@anypromo/shared/types/SaleCustomize'

export interface ICheckOrderOption {
  pageAction: string
  orderType: OrderType
  isBlank: boolean
  isFreeGift: boolean
  couponCode: string
  productSpecList: IProductSpecModel[]
  specList: ISpecModel[]
  addonList: ISpecModel[]
  dropShip: IDropShipModel
  imprintMethodList: ImprintMethodModel[]
  productionTime?: IProductionTimeItem
  // setShippingMethod: (val: IShippingMethod) =>void
}

let requestSeq = 0

function apiPost(
  url: string,
  params: any,
  config?: AxiosRequestConfig
): Promise<any> {
  const sessionGuid = (window as any).sessionGuid
  requestSeq++
  return new Promise((resolve, reject) => {
    axios
      .post(
        url + `&sessionGuid=${sessionGuid}&requestSeq=${requestSeq}`,
        params,
        config
      )
      .then((res) => {
        const data = res.data
        if (data.Code !== 200) {
          // return data.Data
          if (data.Code === 408) {
            Dialog.alert({
              title: '',
              message:
                'Sorry, your session has expired. Please refresh this page to start again.',
              confirmButtonText: 'Refresh',
              allowHtml: true
            }).then((data) => {
              window.location.reload()
            })
            resolve(data.Data)
          } else if (data.code === 401) {
            // 需要登录，弹出登录窗口
            reject(data)
          } else {
            reject(data)
          }
        } else {
          resolve(data.Data)
        }
      })
  })
}

function apiGet(url: string, config?: AxiosRequestConfig): Promise<any> {
  const sessionGuid = (window as any).sessionGuid
  requestSeq++
  return new Promise((resolve, reject) => {
    axios
      .get(url + `&sessionGuid=${sessionGuid}&requestSeq=${requestSeq}`, config)
      .then((res) => {
        const data = res.data
        if (data.Code !== 200) {
          // return data.Data
          if (data.Code === 408) {
            Dialog.alert({
              title: '',
              message:
                'Sorry, your session has expired. Please refresh this page to start again.',
              confirmButtonText: 'Refresh',
              allowHtml: true
            }).then((data) => {
              window.location.reload()
            })
            resolve(data.Data)
          } else if (data.code === 401) {
            // 需要登录，弹出登录窗口
            reject(data)
          } else {
            reject(data)
          }
        } else {
          resolve(data.Data)
        }
      })
  })
}

async function apiPostWithForm(url: string, params: any): Promise<any> {
  //
  return await apiPost(url, params, {
    transformRequest: [
      function (data) {
        /**
         * 在执行请求之前，把请求由 Json 的格式处理成 K-V 的形式
         */
        let ret = ''
        for (const it in data) {
          ret +=
            encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// export async function InitData (productId: number): Promise<any> {
//   const params = new FormData()
//   params.append('ProductId', productId.toString())
//   const response = await axios.post('/Ajax/QuoteCustomizeMobile.ashx?action=init', params)

//   const data = response.data.Data
//   return data
// }

export type CalcDeliveryOption = {
  transitTime?: number
  eta?: any
  ProductionList: number[]
}

const deliveryCache: Record<string, string[]> = {}

export function calcDelivery(options: any): Promise<any> {
  return new Promise((resolve, reject) => {
    const cacheKey = options.ProductionList.join(',') + options.eta
    if (deliveryCache[cacheKey]) {
      resolve(deliveryCache[cacheKey])
    } else {
      const { transitTime } = window as any
      const { Product } = (window as any).productData

      const defaults = {
        ProductID: Product.id,
        TransitTime: transitTime,
        ProductionList: []
      }
      const param = extend({}, defaults, options || {})
      axios
        .post('/ajax/ProductDetail.aspx/GetDeliveryDateRange', param)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.d) {
              deliveryCache[cacheKey] = res.data.d
              if (Array.isArray(options.ProductionList)) {
                options.ProductionList.forEach((p: number, index: number) => {
                  const tcacheKey = p + options.eta
                  deliveryCache[tcacheKey] = [res.data.d[index]]
                })
                deliveryCache[cacheKey] = res.data.d
              }
              resolve(deliveryCache[cacheKey])
            } else {
            }
          }
        })
    }
  })
}

/**
 * 加载订单信息
 * @returns
 */
export async function loadOrderDetail(options: any): Promise<any> {
  let param = {}
  if (options.shoppingCartSysNo) {
    param = {
      shoppingCartSysNo: options.shoppingCartSysNo
    }
  } 

  const url = '/Ajax/OrderCustomizeMobile.ashx?action=loadOrder'
  return await apiPostWithForm(url, param)
}

/**
 * 加载订单信息
 * @returns
 */
export async function addToCart(
  savetoshoppingcart?: number,
  options?: any
): Promise<any> {
  savetoshoppingcart = savetoshoppingcart || 0
  const isAddPlatinum = 0
  const { Product } = (window as any).productData
  const { pageInfo, sessionGuid } = window as any
  const param = {
    sessionguid: sessionGuid,
    productid: Product.id,
    savetoshoppingcart: savetoshoppingcart,
    customerordernotes: '',
    couponCode: options?.couponCode || '',
    isAddVip: isAddPlatinum,
    option: pageInfo.option,
    superrush: pageInfo.superrush,
    customizeEventName: options?.customizeEventName || '',
    customizeEventDate: options?.customizeEventDate || '',
  }

  const url = '/Order_Customize_Attached.aspx?dataType=json'
  return await apiPostWithForm(url, param)
}

/**
 * 保存imprint 信息
 * @param options
 * @returns
 */
export async function checkOrderOption(
  action: string,
  options: ICheckOrderOption
): Promise<any> {
  const { Product } = (window as any).productData
  const { freeSpecSampleType ,p1,p2} = (window as any).pageInfo;

  const productSpecItems = options.productSpecList.map(
    (it: IProductSpecModel) => {
      return {
        IsMultiSize: Product.IsMultiSize,
        productSelectedQty: {
          IsMultiSize: Product.IsMultiSize,
          InputQuantity: it.getQty(),
          SizeQty: Product.IsMultiSize
            ? (it.quantity as IQuantitySize[]).map((f) => {
                return {
                  size: f.size,
                  quantity: f.quantity
                }
              })
            : null
        },
        selectedSpecList: it.productSpec.map((sp) => {
          return {
            name: sp.name,
            selectedText: sp.value.text,
            selectedValue: sp.value.value
          }
        })
      }
    }
  )

  const specItems = options.specList.map((it: ISpecModel) => {
    return {
      Name: it.name,
      SelectedValue: it.value?.value
    }
  })

  const addonItems = options.addonList.map((it: ISpecModel) => {
    return {
      Name: it.name,
      SelectedValue: it.value?.value
    }
  })

  const imprintMethodItems = options.imprintMethodList.map(
    (it: ImprintMethodModel) => {
      return {
        SysNo: it.sysNo,
        Location: it.locationName,
        Method: it.methodName,
        SelectedColors: it.selectedColors,
        ArtworkOptions: it.artworkType,
        IsVirtualDesign: false,
        VirtualDesignImage: null,
        VirtualDesignLogo: [],
        VirtualDesignFonts: [],
        virtualDesignArts: [],
        IsPersonalizationSelected: it.isPersonalizationSelected,
        customerArtworkNotes: it.customerArtworkNotes,
        ArtworkFiles: it.artworkFiles.map((fi) => {
          return {
            SysNo: fi.BoxNetFileSysNo
          }
        })
      }
    }
  )
  if (!options.productionTime) {
    return
  }
  if (options.productionTime.priceList.length === 0) {
    console.log('pri')
    return
  }

  // const priceList = getPriceList({
  //   isBlank: options.isBlank,
  //   productSpecList: options.productSpecList,
  //   specList: options.specList,
  //   addonList: options.addonList,
  //   imprintMethodList: options.imprintMethodList
  // })
  // if (priceList.length === 0) {
  //   return
  // }
  // const price = priceList[0]
  let dropShipValue = ''
  if (options.dropShip && options.dropShip.needDropShip) {
    dropShipValue =
      '1_|_' +
      options.dropShip.locationNum +
      '_|_' +
      (options.dropShip.needAddMore ? '1' : '0')
  }

  const param: any = {
    // selectedShippingMethod: { shippingMethodName: null, shippingMethodAmt: 0, specificinHandDate: '0001-01-01T00:00:00', isFedEx: 0 },
    // FreeGift: null,
    freeSpecSampleType:freeSpecSampleType,
    couponCode: options.couponCode,
    OrderType: options.orderType,
    IsBlank: options.isBlank,
    IsMultiSize: Product.IsMultiSize,
    IsFreeGift:options.isFreeGift ,
    ProductId: Product.id,
    PriceName: options.productionTime?.priceList[0].PriceName,
    ProductSpecSOItems: productSpecItems,
    ImprintSOItems: imprintMethodItems,
    SpecSOItems: specItems,
    AddonSOItems: addonItems,
    ImprintMethodSysNo: 0,
    ProductionTimes: [],
    DropShipValue: dropShipValue,
    RushDay: options.productionTime?.rushDay,
    TransitTime: 0,
    ProductionTime: options.productionTime?.productionTime,
    isPageLoad: false
  }


  const url = `/Ajax/OrderCustomizeMobile.ashx?action=${action}&option=${options.pageAction}&p1=${p1}&p2=${p2}`

  return await apiPost(url, param)
}
/**
 * 获取订单信息
 * @param options
 * @returns
 */
export async function checkOrder(options: ICheckOrderOption): Promise<any> {
  return await checkOrderOption('checkOrder', options)
}

/**
 * 获取imprint price价格
 * @param options
 * @returns
 */
export async function getImprincePrice(
  options: ICheckOrderOption
): Promise<any> {
  return await checkOrderOption('getImprincePrice', options)
}

/**
 *
 * @param checked 是否选中
 * @returns
 */
export async function VIPFreeSpecSample(
  freeSpecSampleType: number,
  checked: boolean
): Promise<any> {
  const params = {
    freeSpecSampleType: freeSpecSampleType,
    checked: checked ? 1 : 0
  }
  const url = '/Ajax/OrderCustomizeMobile.ashx?action=IsVipFreeSpecSample'

  return await apiPostWithForm(url, params)
}

/**
 *
 * @param checked 是否选中
 * @returns
 */
export async function getLastCartItem(
  cartSysNo: number
): Promise<ILastCartItem> {
  const url =
    '/Ajax/OrderCustomize.ashx?action=getCartInfo&cartSysNo=' + cartSysNo

  return await apiGet(url)
}

export async function getCustomerCustomizeEventList(
): Promise<Array<ICustomizeEventInfo>> {
  const url =
    '/Ajax/OrderCustomize.ashx?action=getCustomerCustomizeEventList'

  return await apiGet(url)
}

/**
 *
 * @param checked 是否选中
 * @returns
 */
export async function setSurprise(isSurprise: boolean): Promise<any> {
  // const { Product } = (window as any).productData

  const params = {
    // produ:Product.id,
    isSurprise: isSurprise ? 1 : 0
  }
  const url = '/Ajax/OrderCustomizeMobile.ashx?action=setSurprise'

  return await apiPostWithForm(url, params)
}
